import React from 'react';
import axios from "axios";
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash, faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

import { useState, useEffect, useMemo } from 'react';

const Scheme = () => {
    const [value, setvalue] = useState("");
    const [flag, setFlag] = useState(false);
    const [schemeData, setSchemeData] = useState([]);
    const [schemeValue, setSchemeValue] = useState("");
    const [deleteCode, setDeleteCode] = useState({});
    const [editCode, setEditCode] = useState("");

    useEffect(() => {


        fetchData();
    }, []);

    const fetchData = async () => {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/scheme`);
        setSchemeData(result.data.dataContent);
    };

    useEffect(() => {
        if (flag == true) {
            fetchData()
        }
    }, [flag])

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'schemeName',
                header: 'Scheme Name',
            },
            {
                accessorKey: 'visibility',
                header: 'Visibility',
            },
            {
                accessor: '',
                header: 'Actions',
                Cell: cell => <>
                    <i className="btn text-primary" type="button" onClick={() => handleEditScheme(cell.row.original)}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#myDelete" onClick={() => setDeleteCode({ "SchemeCode": cell.row.original.schemeCode })}> <FontAwesomeIcon icon={faTrashAlt} /></i></>

            },

        ],
        [],
    );

    function removed() {
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "none";
    }

    function handleEditScheme(value) {
        setEditCode({ "SchemeCode": value.schemeCode, "SchemeName": value.schemeName })
        setSchemeValue(value.schemeName)
     
        var x = document.createElement("a")
        x.id = "mpopupLink";
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "block";
    }

    function AddNewScheme() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "SchemeName": schemeValue,
            "Visibility": "Y",
            "IsActive": "Y",
            "CreatedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/scheme`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                }
            })
            .catch(error => console.log('error', error));
    }

    function deleteData(value) {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/scheme`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success == true) {
                    fetchData()

                }
            })
            .catch(error => console.log('error', error));
    }

    function EditScheme() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "SchemeCode": editCode.SchemeCode,
            "SchemeName": schemeValue,
            "Visibility": "Y",
            "IsActive": "Y",
            "ModifiedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/scheme`, requestOptions)
            .then(response => response.text())
            .then(result => {
                alert(JSON.parse(result).message)
                if (JSON.parse(result).success == true) {
                    fetchData()
                    removed()

                }
            }
            )
            .catch(error => console.log('error', error));
    }


    return (
        <>
           
            <main id="main" className="main">

                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Seasons</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Master</li>
                            <li className="breadcrumb-item active">Scheme</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" data-bs-toggle="modal" data-bs-target="#myAdd" onClick={() => setFlag(false)}>Add New</button>
                </div>
                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={schemeData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                />

                            </div>

                        </div>

                    </div>
                </section>

            </main>
            <div className="modal" id="myAdd">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                        </div>

                        <div className="modal-body">
                            <label for="add_season" className="form-label">Add New Scheme</label>
                            <input type="text" className="form-control" placeholder="Add New Season" onChange={e => setSchemeValue(e.target.value)} />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={AddNewScheme}>Add</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>


            <div id="mpopupBox" className="modal">

                <div className="modal-content" >
                    <div className="modal-header">
                        <h2>View Details</h2>
                    </div>
                    <div className="madal-body" id="modal-content" >
                        <label for="edit_scheme" className="form-label">Edit Scheme</label>
                        <input type="text" className="form-control" placeholder="Add New Season" onChange={e => setSchemeValue(e.target.value)} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={EditScheme}>Add</button>
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={removed}>Close</button>
                    </div>
                </div>

            </div>

            <div className="modal" id="myDelete">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                        </div>

                        <div className="modal-body">
                            <p>Are you sure you want to delete this item?</p>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
          
        </>
    )
}

export default Scheme;

